import request from '@/utils/request'

export function addcar (data) {
  return request({
    url: 'cart/add',
    method: 'post',
    data: data
  })
}

export function carlist () {
  return request({
    url: 'cart/list',
    method: 'get'
  })
}

export function cartModify (data) {
  return request({
    url: '/cart/modify',
    method: 'post',
    data
  })
}

export function cartDelete (data) {
  return request({
    url: '/cart/delete',
    method: 'POST',
    data
  })
}
